import {
  Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges,
  ViewChild
} from '@angular/core';
import { NavigationHelper } from "../../helpers/navigation.helper";
import { Subscription } from "rxjs/Subscription";
import { EventService } from "../../services/event.service";
import { NavigationParams, PostReaction } from "../../app/app.interfaces";


@Component({
  selector: 'nav-link',
  template: `<a #link class="navLink" 
								class=" {{ aClass }}"
                [ngClass]="{ 'active': _active===true }" 
                (click)="onClick($event)">
    <ng-content></ng-content></a>`,
})
export class CustomNavLink implements OnInit, OnDestroy {
  
  @Input() shortcut: string = null;
  @Input() route: string;
  @Input() params: any = null;
  @Input() parentRoute?: string = null;
  @Input() parentParams?: any = null;
  @Input() navigationParams?: NavigationParams;  
  @Input() aClass?: string = '';
  @Input() push?: boolean = true;
  @Input() pop?: boolean = false;  
  @Input() popTo?: string = null;  
  
  @Input() nav?: string = null;
  @Input() activeIfComponent: string = null;   
  @Input() ignoreIfActive?: boolean = false;  
  private _active: boolean = false; 
  
  @ViewChild('link') link: ElementRef;
  
  private path: string; 
  private urlChangedSubscription: Subscription;
  private componentChangedSubscription: Subscription;
  
  private shortcuts: any = {
    home:  {
      route: 'post-list-most-recent',
      parentRoute: 'dashboard',
      params: null,
			parentParams: null,
      push: false,
      pop: true,
      popTo: 'dashboard'
    },
    back:  {
      route: 'post-list-most-recent',
      parentRoute: 'dashboard',
      params: null,
			parentParams: null,
      push: false,
      pop: true,
      popTo: null
    },
    search:  {
      route: null,
    }
  };
  
  constructor(public navigationHelper: NavigationHelper, private eventService: EventService) {
    
    
  }

  ngOnDestroy(): void {
    if(this.urlChangedSubscription) this.urlChangedSubscription.unsubscribe();
    if(this.componentChangedSubscription) this.componentChangedSubscription.unsubscribe();
  }
  
  
  ngOnInit(): void {
    
    if(! this.link) return;
    
    if(this.activeIfComponent){      
      this.componentChangedSubscription = this.eventService.componentActivated.subscribe((newComponent) => {
        this._active = (newComponent === this.activeIfComponent);
      });      
    }
    else {
      this.urlChangedSubscription = this.eventService.pathChanged.subscribe((newPath) => {
        this._active = (newPath === this.path);
      });      
    }
    
    
        
    if (this.navigationParams) {
      this.shortcut = this.navigationParams.shortcut;
      this.route = this.navigationParams.route;
      this.params = this.navigationParams.params || null;
      this.parentRoute = this.navigationParams.parentRoute || null;
      this.parentParams = this.navigationParams.parentParams || null;
      this.push = this.navigationParams.push || false;
      this.pop = this.navigationParams.pop || false;
      this.popTo = this.navigationParams.popTo || null;
    }
    
    if (this.shortcut) {
      this.route = this.shortcuts[this.shortcut].route;
      this.parentRoute = this.shortcuts[this.shortcut].parentRoute|| null;
      this.params = this.shortcuts[this.shortcut].params || null;
      this.parentParams = this.shortcuts[this.shortcut].params || null;
      this.push = this.shortcuts[this.shortcut].push|| null;
      this.pop = this.shortcuts[this.shortcut].pop|| null;
      this.popTo = this.shortcuts[this.shortcut].popTo|| null;
    }
    
    if(this.parentRoute !== null && ! this.nav) {
      this.push = false;
    }
    
    if(this.pop){
      this.push = false;
    }
    if(this.route) {

      this.path = this.navigationHelper.generatePath(this.route, this.params, this.parentRoute, this.parentParams);
      if (this.path) {
        this.link.nativeElement.href = '#/' + this.path;

        if (this.activeIfComponent) {
          this._active = this.navigationHelper.currentComponentIs(this.activeIfComponent);
        }
        else {
          this._active = (this.navigationHelper.currentPath === this.path);
        }

      }
    }
  
  }
  
  onClick(ev){

      
    if(this.ignoreIfActive && this._active) {      
      ev.preventDefault();
      return;
    }
    
		this.eventService.toggleMobileSidebar.emit(false);
		
    if(this.push){
      ev.preventDefault();
      this.navigationHelper.pushWithLocationUpdate(this.path, this.route, this.params);
    }
    else if(this.pop && this.navigationHelper.canPop()){
      ev.preventDefault();
      this.navigationHelper.popWithLocationUpdate(this.popTo);      
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/partials/nav-link/nav-link.ts